import React, { useState, useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import StudentSidebar from '../Student/StudentSidebar';
import NotificationBell from './NotificationBell';
import ScoreScaleButton from '../Student/ScoreScaleButton';
import MobileLogo from './MobileLogo';
import PageTransition from './PageTransition';
import { getMyCourses } from '../../services/studentService';
import '../../styles/Student.css';

const LS_KEY = 's_selected_course';

const StudentLayout = () => {
  const [courses, setCourses] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(() => {
    const v = localStorage.getItem(LS_KEY);
    return v ? Number(v) : null;
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    getMyCourses()
      .then(res => {
        const list = res.data || [];
        setCourses(list);
        // Если сохранённый курс больше не доступен (или не выбран) — берём первый.
        setSelectedCourseId(prev => (list.some(c => c.id === prev) ? prev : (list[0]?.id ?? null)));
      })
      .catch(() => {});
  }, []);

  const selectCourse = (id) => {
    setSelectedCourseId(id);
    if (id != null) localStorage.setItem(LS_KEY, String(id));
  };

  useEffect(() => { setSidebarOpen(false); }, [location]);

  const course = useMemo(() => courses.find(c => c.id === selectedCourseId) || null, [courses, selectedCourseId]);
  const courseName = course?.name || '';

  // На полноэкранных страницах (урок, решение ДЗ, работа над ошибками) прячем
  // колокольчик — он перекрывает шапку этих экранов.
  const fullScreen = /^\/lesson\//.test(location.pathname) || /^\/homework\/\d/.test(location.pathname) || /^\/variant\//.test(location.pathname) || /^\/mistakes/.test(location.pathname);
  // Кнопка «Шкала перевода баллов» — только в разделе «Варианты», слева от колокольчика.
  const onVariants = /^\/tests/.test(location.pathname);

  return (
    <div className="student-container">
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}
      <StudentSidebar
        courses={courses}
        selectedCourseId={selectedCourseId}
        onSelectCourse={selectCourse}
        isOpen={sidebarOpen}
      />

      <div className="student-main">
        {!fullScreen && onVariants && <ScoreScaleButton courseId={selectedCourseId} examType={course?.examType} />}
        {!fullScreen && <NotificationBell />}
        {/* Mobile top bar */}
        <div className="mobile-topbar">
          <button className="hamburger-btn" onClick={() => setSidebarOpen(o => !o)}>
            <span /><span /><span />
          </button>
          <MobileLogo />
          {/* правые кнопки держим одной группой — иначе space-between разносил
              «шкалу баллов» и колокольчик по разным краям */}
          <div className="mob-actions">
            {onVariants && <ScoreScaleButton courseId={selectedCourseId} examType={course?.examType} variant="inline" />}
            <NotificationBell variant="inline" />
          </div>
        </div>
        <PageTransition>
          <Outlet context={{ courses, selectedCourseId, setSelectedCourseId: selectCourse, course, courseName }} />
        </PageTransition>
      </div>
    </div>
  );
};

export default StudentLayout;
